import { NgModule } from '@angular/core';
import { MessagesRoutingModule } from './messages-routing.module';
import { StreamAutocompleteTextareaModule } from 'stream-chat-angular';
import { MessageContextStorage } from './application/context-storage';

@NgModule({
  imports: [MessagesRoutingModule, StreamAutocompleteTextareaModule],
  providers: [MessageContextStorage]
})
export class MessagesModule {}
